const normalizeName = (name) =>
  name.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');

const getVillagersName = (inputValue, villagers, setFilteredVillagers) => {
  const results = villagers.filter(({ _id }) => {
    const id = _id;
    const villagerName = id.toUpperCase().substring(0, inputValue.length);

    return (
      normalizeName(villagerName) === normalizeName(inputValue.toUpperCase())
    );
  });

  if (inputValue === '') {
    return setFilteredVillagers([]);
  }
  return setFilteredVillagers(results);
};

export default getVillagersName;
